module.exports = __webpack_public_path__ + "img/NoPhotoAvailable.d590e000.jpg";